var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"justify-center grey--text",attrs:{"padless":""}},[_c('v-icon',[_vm._v("mdi-lock-check")]),_vm._v("Transaction secured by Strategic Explorations. ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }